/* tslint:disable */
/* eslint-disable */
/**
 * Boatsetter API
 * Endpoints require an access token set via the `X-UserToken` header
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface DomesticV2BoatsBoatIdAddOnsGetRequest
 */
export interface DomesticV2BoatsBoatIdAddOnsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof DomesticV2BoatsBoatIdAddOnsGetRequest
     */
    'add_on_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof DomesticV2BoatsBoatIdAddOnsGetRequest
     */
    'price_cents'?: number;
    /**
     * 
     * @type {string}
     * @memberof DomesticV2BoatsBoatIdAddOnsGetRequest
     */
    'price_type'?: DomesticV2BoatsBoatIdAddOnsGetRequestPriceTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof DomesticV2BoatsBoatIdAddOnsGetRequest
     */
    'max_quantity'?: number;
    /**
     * 
     * @type {string}
     * @memberof DomesticV2BoatsBoatIdAddOnsGetRequest
     */
    'description'?: string;
}

export const DomesticV2BoatsBoatIdAddOnsGetRequestPriceTypeEnum = {
    booking: 'per_booking',
    hour: 'per_hour',
    passenger: 'per_passenger'
} as const;

export type DomesticV2BoatsBoatIdAddOnsGetRequestPriceTypeEnum = typeof DomesticV2BoatsBoatIdAddOnsGetRequestPriceTypeEnum[keyof typeof DomesticV2BoatsBoatIdAddOnsGetRequestPriceTypeEnum];


